// 数字转换单位k
export function numToUnit(num) {
    num = Number(num);
    return num > 999 ? (num / 1000).toFixed(1) + 'k' : num;
}

// 预览链接前缀展示（窄屏可截断为相对路径，仅用于 UI，不可用于 window.open）
export function formatPreviewUrl(url, width) {
    if (!url || typeof url !== 'string') return url || '';
    let previewUrl = Boolean(width < 1000 && url.slice(-1) === '/') ? `/${url.split('/')[url.split('/').length - 2]}/` : url;
    return previewUrl;
}

// 多语言链接（要求传入带协议域名的完整前缀）
export function formatOutUrl(url, lang, val) {
    if (!url || typeof url !== 'string') return `${val || ''}`;
    let index = url.indexOf("/", url.indexOf("/") + 2); // 找到第三个 "/" 的位置
    if (index < 0) return `${url}${val || ''}`;
    let firstPart = url.substring(0, index); // 截取第一个部分
    let secondPart = url.substring(index + 1); // 截取第二个部分

    return `${firstPart}/${lang.includes('pt') ? 'pt' : lang.includes('zh') ? 'zh' : lang}/${secondPart}${val}`
}